import React from 'react';

import Modal from '../../commonComponents/util/Modal';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import Select from '../../commonComponents/util/Select';
import Toggle from '../../commonComponents/util/Toggle';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import BankAddress from './BankAddress';
import ReturnAddress from '../../settingComponents/systemSettings/paymentSettings/ReturnAddress';
import StartingAmountInput from './StartingAmountInput';
import CurrencyFormatInput from "../../commonComponents/util/CurrencyFormatInput";

import NumberFormat from 'react-number-format';

import { Departments } from '../../../lib/systemVariables';
import { getRequest } from '../../../lib/apiUtils';

import { validateFieldLength, deepEquals, formatCurrency, formatDate, concatenateGeosuggestLabel } from '../../../lib/utils';
import FundReturnAddress from './FundReturnAddress';

export default class FundModal extends React.Component {

    constructor(props) {
        super(props);

        const { fund } = this.props;

        this.initialState = {
            fund: {
                fundName: fund && fund.name ? fund.name : '',
                active: fund && typeof fund.active === 'boolean' ? fund.active : true,
                bankId: fund && fund.bankId ? fund.bankId : '',
                bankRoutingNumber: fund && fund.bankRoutingNumber ? fund.bankRoutingNumber : '',
                bankAddress: fund && fund.bankAddress ? fund.bankAddress : {},
                returnAddress: fund && fund.returnAddress ? fund.returnAddress : {},
                checkMemo: fund && fund.checkMemo ? fund.checkMemo : '',
                reportMemo: fund && fund.reportMemo ? fund.reportMemo : '',
                includeCampaignListOnCheck: fund && fund.includeCampaignListOnCheck ? fund.includeCampaignListOnCheck : false,
                allowACH: fund && fund.allowACH ? fund.allowACH : false,
                banquestSourceKey: fund && fund.banquestSourceKey ? fund.banquestSourceKey : '',
                banquestPin: fund && fund.banquestPin ? fund.banquestPin : '',
                accountNumber: fund && fund.accountNumber ? fund.accountNumber : '',
                startingAmount: fund ? fund.startingAmount : '',
                startingDate: fund && fund.startingDate ? fund.startingDate : '',
                startingCheckNumber: fund && fund.checkNumber ? fund.checkNumber : '',
                department: fund && fund.department ? fund.department : Departments.US,
                limitedApprovalMax: fund && fund.limitedApprovalMax ? fund.limitedApprovalMax : '',
                autoSignedCheckLimit: fund && fund.autoSignedCheckLimit ? fund.autoSignedCheckLimit : '',
                checkCuttingMax: fund && fund.checkCuttingMax ? fund.checkCuttingMax : '',
                wiringMax: fund && fund.wiringMax ? fund.wiringMax : '',
                frac1: '',
                frac2: '',
            },
            editMode: !!(fund && fund.fundId),

            submitAttempted: false,
            error: false,
            dataErrors: {}
        };

        this.state = {
            ...this.initialState,
            showDecryptedSourceKey: false,
            showDecryptedPin: false,
            decryptedSourceKey: '',
            decryptedPin: '',
            loadingCredentials: false,
            originalSourceKey: fund && fund.banquestSourceKey ? fund.banquestSourceKey : '',
            originalPin: fund && fund.banquestPin ? fund.banquestPin : ''
        };

        this.onChange = this.onChange.bind(this);
        this.toggleSourceKeyVisibility = this.toggleSourceKeyVisibility.bind(this);
        this.togglePinVisibility = this.togglePinVisibility.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!deepEquals(nextProps.fund, this.props.fund) && nextProps.fund.fundId) {

            const { fund } = nextProps;
            const fracNums = fund.fractionalNumber.split('-');
            this.initialState = {
                ...this.state, fund: {
                    fundName: nextProps.fund.name || '',
                    active: typeof fund.active === 'boolean' ? fund.active : true,
                    bankId: fund.bankId || '',
                    bankRoutingNumber: fund.bankRoutingNumber || '',
                    bankAddress: fund.bankAddress ? fund.bankAddress : {},
                    returnAddress: fund.returnAddress ? fund.returnAddress : {},
                    checkMemo: fund.checkMemo || '',
                    reportMemo: fund.reportMemo || '',
                    includeCampaignListOnCheck: fund.includeCampaignListOnCheck || false,
                    allowACH: fund.allowACH || false,
                    banquestSourceKey: fund.banquestSourceKey || '',
                    banquestPin: fund.banquestPin || '',
                    accountNumber: fund.accountNumber || '',
                    startingAmount: fund.startingAmount || 0,
                    startingDate: fund.startingDate || '',
                    startingCheckNumber: fund.checkNumber.toString() || '',
                    department: fund.department || Departments.US,
                    limitedApprovalMax: fund.limitedApprovalMax || '',
                    autoSignedCheckLimit: fund.autoSignedCheckLimit || '',
                    checkCuttingMax: fund.checkCuttingMax || '',
                    wiringMax: fund.wiringMax || '',
                    frac1: fracNums[0],
                    frac2: fracNums[1],
                }, editMode: true
            };
            this.setState({
                ...this.initialState,
                originalSourceKey: fund.banquestSourceKey || '',
                originalPin: fund.banquestPin || ''
            });
        }
    }

    onChange(name, value) {
        if (name === "department" && value === Departments.IL) {
            this.setState({
                fund: {
                    ...this.state.fund,
                    [name]: value,
                    checkMemo: '',
                    startingCheckNumber: ''
                }
            });
            return;
        }

        if (name === "banquestSourceKey" || name === "banquestPin") {
            const newFund = { ...this.state.fund, [name]: value };

            if (!newFund.banquestSourceKey || !newFund.banquestPin) {
                newFund.allowACH = false;
            }

            this.setState({ fund: newFund });

            return;
        }

        this.setState({
            fund: { 
                ...this.state.fund, 
                [name]: value 
            }
        });
    }
    

    validateLength(name, length, value) {
        const isValid = validateFieldLength(length, value);
        this.setState({ dataErrors: { ...this.state.dataErrors, [name]: !isValid } });
        return isValid;
    }

    onClose() {
        this.props.close();
        this.setState({
            ...this.initialState,
            showDecryptedSourceKey: false,
            showDecryptedPin: false,
            decryptedSourceKey: '',
            decryptedPin: '',
            loadingCredentials: false,
            originalSourceKey: this.props.fund && this.props.fund.banquestSourceKey ? this.props.fund.banquestSourceKey : '',
            originalPin: this.props.fund && this.props.fund.banquestPin ? this.props.fund.banquestPin : ''
        });
    }

    async onSubmit() {
        this.setState({ error: false, submitAttempted: true });

        const fund = { ...this.state.fund };
        
        // Sync decrypted values back to the fund when visible
        if (this.state.showDecryptedSourceKey) {
            fund.banquestSourceKey = this.state.decryptedSourceKey || '';
        }
        if (this.state.showDecryptedPin) {
            fund.banquestPin = this.state.decryptedPin || '';
        }
        
        if (!fund.fundName || !fund.bankId || !fund.frac1 || !fund.frac2 || !fund.bankRoutingNumber || !fund.bankAddress.streetNumber || !fund.bankAddress.street
            || !fund.bankAddress.city || !fund.bankAddress.country || !fund.accountNumber || !fund.startingAmount && !fund.startingAmount === 0 ||
            !fund.startingDate || (fund.department === Departments.US && !fund.startingCheckNumber) ||
            (fund.department === Departments.US && !fund.limitedApprovalMax && this.props.userPermissions.admin) ||
            (fund.department === Departments.US && !fund.checkCuttingMax && this.props.userPermissions.admin) ||
            (fund.department === Departments.US && !fund.autoSignedCheckLimit && this.props.userPermissions.admin) ||
            (fund.department === Departments.IL && !fund.wiringMax)) return;

        fund.fractionalNumber = `${fund.frac1}-${fund.frac2}`;
        delete fund.frac1;
        delete fund.frac2;
        if (this.state.editMode) {
            fund.checkNumber = fund.startingCheckNumber;
            delete fund.startingCheckNumber;
            delete fund.startingAmount;
            delete fund.startingDate;
            delete fund.department;
            // For existing funds, only send credentials when visible (decrypted) to avoid re-encrypting masked values
            if (!this.state.showDecryptedSourceKey) {
                delete fund.banquestSourceKey;
            }
            if (!this.state.showDecryptedPin) {
                delete fund.banquestPin;
            }
        }

        // No special handling for clears; rely on backend behavior

        await this.props.createFund(fund);

        if (this.props.success) {
            this.onClose();
        } else {
            this.setState({ error: true });
        }
    }

    async fetchDecryptedCredentials() {
        if (!this.props.fund || !this.props.fund.fundId) return;

        this.setState({ loadingCredentials: true });
        try {
            const result = await getRequest(`/funds/${this.props.fund.fundId}/credentials`);
            if (result.success) {
                this.setState({
                    decryptedSourceKey: result.data.sourceKey || '',
                    decryptedPin: result.data.pin || '',
                    loadingCredentials: false
                });
            } else {
                console.error('Failed to fetch decrypted credentials:', result.message);
                this.setState({ loadingCredentials: false });
            }
        } catch (error) {
            console.error('Error fetching decrypted credentials:', error);
            this.setState({ loadingCredentials: false });
        }
    }

    isSourceKeyModified() {
        return this.state.fund.banquestSourceKey !== this.state.originalSourceKey;
    }

    isPinModified() {
        return this.state.fund.banquestPin !== this.state.originalPin;
    }

    async toggleSourceKeyVisibility() {
        const newVisibility = !this.state.showDecryptedSourceKey;

        // Hiding: sync decrypted value back into fund state
        if (!newVisibility && this.state.showDecryptedSourceKey) {
            this.setState({
                showDecryptedSourceKey: newVisibility,
                fund: { ...this.state.fund, banquestSourceKey: this.state.decryptedSourceKey }
            });
            return;
        }

        // Showing: decide whether to fetch or just prepare local editing
        if (newVisibility) {
            const hasExistingCred = !!(this.state.originalSourceKey || this.state.fund.banquestSourceKey);
            // If we have an existing credential but no decrypted value yet, fetch it
            if (hasExistingCred && !this.state.decryptedSourceKey && this.props.fund && this.props.fund.fundId) {
                await this.fetchDecryptedCredentials();
            }
            // If no existing credential, still allow editing by using current (possibly empty) fund value
            if (!hasExistingCred) {
                this.setState({
                    showDecryptedSourceKey: true,
                    decryptedSourceKey: this.state.fund.banquestSourceKey || ''
                });
                return;
            }
        }

        this.setState({ showDecryptedSourceKey: newVisibility });
    }

    async togglePinVisibility() {
        const newVisibility = !this.state.showDecryptedPin;

        // Hiding: sync decrypted value back into fund state
        if (!newVisibility && this.state.showDecryptedPin) {
            this.setState({
                showDecryptedPin: newVisibility,
                fund: { ...this.state.fund, banquestPin: this.state.decryptedPin }
            });
            return;
        }

        // Showing: decide whether to fetch or just prepare local editing
        if (newVisibility) {
            const hasExistingCred = !!(this.state.originalPin || this.state.fund.banquestPin);
            if (hasExistingCred && !this.state.decryptedPin && this.props.fund && this.props.fund.fundId) {
                await this.fetchDecryptedCredentials();
            }
            if (!hasExistingCred) {
                this.setState({
                    showDecryptedPin: true,
                    decryptedPin: this.state.fund.banquestPin || ''
                });
                return;
            }
        }

        this.setState({ showDecryptedPin: newVisibility });
    }


    render() {
        const { fund, submitAttempted } = this.state;
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal new-fund-modal large-modal">
                        <div className="modal-header" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                            <div>
                                <h4 className="page-header">{this.state.editMode ? 'Edit' : 'New'} Fund</h4>
                                <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px'}}>
                                    <label className="input-label" style={{marginBottom: 0}}>Active</label>
                                    <Toggle
                                        id={this.state.editMode ? this.props.fund.fundId : 'new-fund'}
                                        name="active"
                                        value={fund.active}
                                        onChange={this.onChange} />
                                </div>
                            </div>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)} />
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<input type="text" />}
                                        label="Fund Name" name="fundName" value={fund.fundName}
                                        onChange={this.onChange}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-quarter">
                                    {this.state.editMode ?
                                        <div>
                                            <label className="input-label">Starting Date</label>
                                            <input type="text" value={formatDate(fund.startingDate)} disabled />
                                        </div> 
                                        :<div>
                                            <ValidatedInput input={<input type="date" max="9999-12-31"/>}
                                            label="Starting Date" name="startingDate"
                                            value={fund.startingDate} onChange={this.onChange}
                                            required={true} showRequiredError={submitAttempted} />
                                        </div>
                                    }
                                </div>
                                <div className="column-quarter">
                                    {this.state.editMode ?
                                        <div>
                                            <label className="input-label">Starting Amount</label>
                                            <input type="text" value={formatCurrency(fund.startingAmount, fund.department === Departments.IL)} disabled />
                                        </div>
                                        : <ValidatedInput input={<StartingAmountInput
                                            isIsraeli={fund.department === Departments.IL} />}
                                            name="startingAmount" value={fund.startingAmount}
                                            onChange={this.onChange} label="Starting Amount"
                                            required={true} showRequiredError={submitAttempted && fund.startingAmount !== '0' && !fund.startingAmount} />}
                                </div>
                            </div>
                            <div className="modal-row fund-section-divider-row">
                                <div className="modal-section-header">
                                    <label className="input-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Bank Info</label>
                                </div>
                            </div>
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<Select options={this.props.utils.banks} />}
                                        label="Bank" name="bankId" value={fund.bankId}
                                        onChange={this.onChange}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-half">
                                    <label
                                        className={`input-label ${submitAttempted && (!fund.frac1 || !fund.frac2) ? "error-label" : ""}`}>Bank
                                        Fractional No.</label>
                                    <div className="flex-center flex-justify bank-fractional-no">
                                        <ValidatedInput input={<NumberFormat placeholder="##" format="##"
                                            onValueChange={(vals) => this.onChange('frac1', vals.value)} />}
                                            value={fund.frac1} required={true}
                                            showRequiredError={submitAttempted} />
                                        <p>-</p>
                                        <ValidatedInput input={<NumberFormat placeholder="####" format="####"
                                            onValueChange={(vals) => this.onChange('frac2', vals.value)} />}
                                            value={fund.frac2} required={true}
                                            showRequiredError={submitAttempted} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-row">
                                <div className="column-third">
                                    <ValidatedInput input={<NumberFormat placeholder='#########' format='#########'
                                        onValueChange={(values) => this.onChange('bankRoutingNumber', values.value)} />}
                                        label="Bank Routing Number" name="bankRoutingNumber"
                                        value={fund.bankRoutingNumber}
                                        errorMessage="Invalid Bank Routing Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'routingNumber', 9)}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-third">
                                    <ValidatedInput input={<NumberFormat placeholder='#########' format='#########'
                                        onValueChange={(values) => this.onChange('accountNumber', values.value)} />}
                                        label="Account No." name="accountNumber" value={fund.accountNumber}
                                        errorMessage="Invalid Account Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'accountNumber', 9)}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-third">
                                    {this.state.editMode ?
                                        <div>
                                            <label className="input-label">Department</label>
                                            <input type="text" value={fund.department} disabled />
                                        </div>
                                        : <RadioGroup onChange={this.onChange} options={this.props.utils.departments}
                                            title="Department" name="department" value={fund.department} />}
                                </div>
                            </div>
                          
                                <BankAddress
                                    address={fund.bankAddress}
                                    updateAddress={this.onChange.bind(this, 'bankAddress')}
                                    showRequiredError={submitAttempted}
                                    addressLabel={concatenateGeosuggestLabel(fund.bankAddress, fund.department === Departments.IL)} />
                         
                            {fund.department === Departments.US &&
                            <div>
                             <div className="modal-row fund-section-divider-row">
                                <div className="modal-section-header">
                                    <label className="input-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Check Settings</label>
                                </div>
                            </div>
                           
                                <FundReturnAddress
                                    address={fund.returnAddress}
                                    unitTypes={(this.props.utils && this.props.utils.unitTypes) ? this.props.utils.unitTypes : []}
                                    updateAddress={this.onChange.bind(this, 'returnAddress')}
                                    showRequiredError={submitAttempted}
                                    addressLabel={concatenateGeosuggestLabel(fund.returnAddress, fund.department === Departments.IL)} />
                            
                                <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<NumberFormat placeholder='######' format='##########'
                                            onValueChange={(values) => this.onChange('startingCheckNumber', values.value)} />}
                                            label={this.state.editMode ? "Check No." : "Starting Check No."}
                                            name="startingCheckNumber" value={fund.startingCheckNumber}
                                            errorMessage="Invalid Check Number"
                                            validated={true} showValidationError={true}
                                            validate={this.validateLength.bind(this, 'startingCheckNumber', 6)}
                                            required={true} showRequiredError={submitAttempted} />
                                    </div>
                                    <div className="column-half">
                                        <label className="input-label">Check Memo</label>
                                        <input type="text" name="checkMemo" value={fund.checkMemo}
                                            onChange={(e) => this.onChange(e.target.name, e.target.value)} />
                                    </div>
                                </div>
                                </div>}
                                {fund.department === Departments.US && this.props.userPermissions.admin &&
                                <div className="modal-row">
                                    <div className="column-third">
                                        <ValidatedInput
                                            input={<CurrencyFormatInput isIsraeli={fund.department === Departments.IL}/>}
                                            label="Auto Signed Check Limit"
                                            name="autoSignedCheckLimit"
                                            onChange={this.onChange}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            value={fund.autoSignedCheckLimit} />
                                        </div>
                                        <div className="column-third">
                                        <ValidatedInput
                                            input={<CurrencyFormatInput isIsraeli={fund.department === Departments.IL}/>}
                                            label="Max Check Amount"
                                            name="checkCuttingMax"
                                            onChange={this.onChange}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            value={fund.checkCuttingMax} />
                                        </div>
                                        <div className="column-third">        
                                        <ValidatedInput
                                            input={<CurrencyFormatInput isIsraeli={fund.department === Departments.IL}/>}
                                            label="Limited Approval Max"
                                            name="limitedApprovalMax"
                                            onChange={this.onChange}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            value={fund.limitedApprovalMax} />
                                    </div>
                                </div>}

                            {fund.department === Departments.IL &&
                                <div className="modal-row">
                                    <div>
                                        <ValidatedInput
                                            input={<CurrencyFormatInput isIsraeli={fund.department === Departments.IL}/>}
                                            label="Wiring Max"
                                            name="wiringMax"
                                            onChange={this.onChange}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            value={fund.wiringMax} />
                                    </div>
                                </div>
                            }

                            <div className="custom-check-container">
                                <input
                                    type="checkbox"
                                    id="includeCampaignList"
                                    className="custom-check"
                                    name="includeCampaignListOnCheck"
                                    onChange={event => this.onChange(event.target.name, event.target.checked)}
                                    checked={fund.includeCampaignListOnCheck} />
                                <label htmlFor="includeCampaignList" className="input-label">Include campaign list on Check Memo</label>
                            </div>
                            <div className="modal-row fund-section-divider-row">
                                <div className="modal-section-header">
                                    <label className="input-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>ACH Settings</label>
                                </div>
                            </div>
                            <div className="modal-row">
                                <div className="column-half">
                                    <label className="input-label">Banquest Source Key</label>
                                    <div className="input-with-button">
                                        <input 
                                            type={this.state.showDecryptedSourceKey ? "text" : "password"}
                                            name="banquestSourceKey"
                                            value={this.state.showDecryptedSourceKey ? this.state.decryptedSourceKey : fund.banquestSourceKey}
                                            onChange={(e) => {
                                                if (this.state.showDecryptedSourceKey) {
                                                    this.setState({ decryptedSourceKey: e.target.value });
                                                    this.onChange(e.target.name, e.target.value);
                                                } else if (!this.state.editMode) {
                                                    // Allow masked entry for new funds
                                                    this.onChange(e.target.name, e.target.value);
                                                }
                                            }}
                                            readOnly={this.state.editMode ? !this.state.showDecryptedSourceKey : false}
                                        />
                                        <button 
                                            type="button"
                                            className="eye-button"
                                            onClick={this.toggleSourceKeyVisibility}
                                            disabled={this.state.loadingCredentials}
                                            title={this.state.showDecryptedSourceKey ? "Hide decrypted value" : "Show decrypted value"}
                                        >
                                            <i className={`icon ${this.state.showDecryptedSourceKey ? 'ion-ios-eye' : 'ion-ios-eye-outline'}`} />
                                        </button>
                                    </div>
                                </div>
                                <div className="column-half">
                                    <label className="input-label">Banquest PIN</label>
                                    <div className="input-with-button">
                                        <input 
                                            type={this.state.showDecryptedPin ? "text" : "password"}
                                            name="banquestPin"
                                            value={this.state.showDecryptedPin ? this.state.decryptedPin : fund.banquestPin}
                                            onChange={(e) => {
                                                if (this.state.showDecryptedPin) {
                                                    this.setState({ decryptedPin: e.target.value });
                                                    this.onChange(e.target.name, e.target.value);
                                                } else if (!this.state.editMode) {
                                                    // Allow masked entry for new funds
                                                    this.onChange(e.target.name, e.target.value);
                                                }
                                            }}
                                            readOnly={this.state.editMode ? !this.state.showDecryptedPin : false}
                                        />
                                        <button 
                                            type="button"
                                            className="eye-button"
                                            onClick={this.togglePinVisibility}
                                            disabled={this.state.loadingCredentials}
                                            title={this.state.showDecryptedPin ? "Hide decrypted value" : "Show decrypted value"}
                                        >
                                            <i className={`icon ${this.state.showDecryptedPin ? 'ion-ios-eye' : 'ion-ios-eye-outline'}`} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                             <div className="custom-check-container">
                                <input
                                    type="checkbox"
                                    id="allowACH"
                                    className="custom-check"
                                    name="allowACH"
                                    onChange={event => this.onChange(event.target.name, event.target.checked)}
                                    checked={fund.allowACH}
                                    disabled={!fund.banquestSourceKey || !fund.banquestPin} />
                                <label htmlFor="allowACH" className={`input-label ${(!fund.banquestSourceKey || !fund.banquestPin) ? 'disabled' : ''}`}>
                                    Allow ACH
                                </label>
                            </div>
                        </div>

                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                                <button className="btn btn-primary"
                                    disabled={Object.keys(this.state.dataErrors).some(k => this.state.dataErrors[k]) || deepEquals(this.initialState.fund, this.state.fund)}
                                    onClick={this.onSubmit.bind(this)}>{this.state.editMode ? 'Update' : 'Submit'}</button>
                                <FadeOutErrorMessage show={this.state.error} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundsCommon/FundModal.jsx